import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { MainContent } from '../../../components/MainContent'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { RecapExtraInsurance } from '../../../containers/carkulka/RecapExtraInsurance.1'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { MeetingRecordCarExtraForm } from '../../../containers/MeetingRecordCarExtraForm'
import { addonOffersContext, AddonOffersProvider } from '../../../context/OfferAddonContext'
import { StepsContent } from '../../../context/StepsContext'
import { useGetInsurances } from '../../../hooks/useInsuranceParams'
import { useGetMeetingRecord } from '../../../hooks/useWizard'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { meetingRecordContext } from '../../carkulka/wizard/5'
import { CompletedPage } from './completed'

const Step4WrapperComponent = () => {
  const { insuranceParams } = useContext(insuranceParamsContext)

  if (!insuranceParams) return null

  return (
    <AddonOffersProvider insuranceParams={insuranceParams as InsuranceParamsDto}>
      <Step4Component />
    </AddonOffersProvider>
  )
}

const Step4Component = () => {
  const navigate = useNavigate()
  const { insuranceParams, insuranceParamsId, isLoadingData: isLoadingInsuranceParams } = useContext(insuranceParamsContext)
  const { addonOffers, isLoadingData, refetch: refetchAddonOffers } = useContext(addonOffersContext)
  const insuranceResults = useGetInsurances(addonOffers.map(x => x.offerId))
  const anyContracted = insuranceResults && insuranceResults.findIndex(x => !!x.data?.data?.contractNumber) >= 0

  const { isLoading, isFetching, data, refetch } = useGetMeetingRecord(insuranceParamsId!, { enabled: false, gcTime: 0 })

  if (!isLoadingInsuranceParams && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 4) {
    navigate('/carkulka/extra/wizard/too-far', { replace: true })
  }

  const handleSubmitCallback = () => Promise.all(insuranceResults.map(x => x.refetch()))

  // vynuceni nacteni dat
  useEffect(() => {
    if (insuranceParamsId) {
      refetch()
      refetchAddonOffers()
    }
  }, [insuranceParamsId])

  return (
    <Section>
      <Container>
        <meetingRecordContext.Provider
          value={{
            isLoading: isFetching || isLoading,
            refetch: refetch,
            meetingRecord: data?.data
          }}>
          {isLoadingData && <Loading large={true} />}

          {!anyContracted && addonOffers.length > 0 &&
            <StepsContent step={4}>
              <Steps icon="car" />

              <InsuranceInfo />

              <MainContent>
                <RecapExtraInsurance />

                <MeetingRecordCarExtraForm handleCreateContractsCallback={handleSubmitCallback} />
              </MainContent>

            </StepsContent>
          }

          {anyContracted && addonOffers.length > 0 && <CompletedPage />}
        </meetingRecordContext.Provider>

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}

export const Step4 = Step4WrapperComponent